
define('tpl!taoQtiItem/qtiCreator/tpl/toolbars/matchInteraction.adder', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"clearfix add-options\" data-edit=\"question\">\n    <div class=\"rgt\">\n        <span class=\"add-option\" data-role=\"add-row\"><span class=\"icon-add\"></span>Add new row</span>\n        <span class=\"add-option\" data-role=\"add-col\"><span class=\"icon-add\"></span>Add new column</span>\n    </div>\n</div>";
  });
});

